import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/components/Dashboard";
import ModelStudio from "@/components/ModelStudio";
import AgenticAI from "@/components/AgenticAI";
import IncidentsPage from "@/components/IncidentsPage";
import ProblemsPage from "@/components/ProblemsPage";
import Remediation from "@/components/Remediation";
import DetectionRules from "@/components/DetectionRules";
import Anomalies from "@/components/Anomalies";
import EventLogs from "@/components/EventLogs";
import NoiseFilters from "@/components/NoiseFilters";
import DataPipeline from "@/components/DataPipeline";
import Integrations from "@/components/Integrations";
import Analytics from "@/components/Analytics";
import Layout from "@/components/Layout";

// AppSupport pages
import OperatorDashboard from "@/components/AppSupport/OperatorDashboard";
import AppIntake from "@/components/AppSupport/AppIntake";
import AppInventory from "@/components/AppSupport/AppInventory";
import ProcessRegistry from "@/components/AppSupport/ProcessRegistry";
import IncidentDetail from "@/components/AppSupport/IncidentDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/model-studio" element={<ModelStudio />} />
            <Route path="/agentic-ai" element={<AgenticAI />} />
            <Route path="/incidents" element={<IncidentsPage />} />
            <Route path="/problems" element={<ProblemsPage />} />
            <Route path="/remediation" element={<Remediation />} />
            <Route path="/detection-rules" element={<DetectionRules />} />
            <Route path="/anomalies" element={<Anomalies />} />
            <Route path="/event-logs" element={<EventLogs />} />
            <Route path="/noise-filters" element={<NoiseFilters />} />
            <Route path="/data-pipeline" element={<DataPipeline />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/analytics" element={<Analytics />} />
            {/* AppSupport Routes */}
            <Route path="/appsupport/dashboard" element={<OperatorDashboard />} />
            <Route path="/appsupport/intake" element={<AppIntake />} />
            <Route path="/appsupport/inventory" element={<AppInventory />} />
            <Route path="/appsupport/registry" element={<ProcessRegistry />} />
            <Route path="/appsupport/incidents/:incidentId" element={<IncidentDetail />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
